import React from 'react';
import styled from 'styled-components';
import { LoadingSpinner } from 'wg-fe-ui';

interface Props {
  className?: string;
  opacity?: number;
}

const LoadingOverlay: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  opacity = 0.9,
  children,
}) => {
  return (
    <Container className={className} opacity={opacity}>
      <LoadingSpinner />
      {children}
    </Container>
  );
};

const Container = styled.div<{ opacity: number }>`
  display: flex;
  flex-direction: column;
  grid-gap: 0.8rem;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ opacity }) => `rgba(100%, 100%, 100%, ${opacity})`};
  z-index: 2;
  animation: fadeIn 0.2s;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export default LoadingOverlay;
